import { useEffect, useState } from "react";
import { useAuth } from "../../../../context/authProvider";
import { useWatches } from "../../../../context/watchProvider"
import TemplateStars from "../../../core/templateStars";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { StarLineIcon } from "../../../../img/svg/adminIcons";
import RequestModal from "./requestModal";
import { parseTimestamp } from "../../../../utils/functions";
import AdminToast from "../../../core/admin/adminToast";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../../firebase";

export default function MyReviews() {

    const { getAdvertiserReviews } = useWatches();
    const { userId } = useAuth();

    const [reviews, setReviews] = useState<{ id: string, rate: number; review: string; createdAt: Date; }[] | null>(null);
    const [requests, setRequests] = useState<{review: string, id: string}[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [editableReview, setEditableReview] = useState<{ id: string, rate: number; review: string; createdAt: Date; } | null>(null);
    const [editableRequest, setEditableRequest] = useState<{id: string, review: string} | undefined>(undefined);
    const [requestModal, setRequestModal] = useState(false);

    const [goodToast, setGoodToast] = useState(false);
    const [badToast, setBadToast] = useState(false);

    useEffect(() => {
        doGetRequests();
        doGetReviews();
        // eslint-disable-next-line
    }, [])

    const doGetReviews = async () => {
        if (!userId) {
            return null;
        }
        setLoading(true);
        const revs = await getAdvertiserReviews(userId);
        if(!revs){
            return null;
        }
        setReviews(revs.filter(r => !r.hidden));
        setLoading(false);
    }

    const doGetRequests = async () => {
        try{
            setLoading(true);
            let reqs: {review: string, id: string}[] = [];
            const q = query(collection(db, "reviewsrequests"), where("advertiser", "==", userId), where("solved", "==", false));
            const docSnap = await getDocs(q);
            if (docSnap.empty) {
                setLoading(false);
                return null;
            }

            docSnap.forEach(document => {
                reqs.push({
                    review: document.data().review,
                    id: document.id
                });
            })
            setRequests(reqs);
            setLoading(false);
        }catch(error){
            console.log(error);
            setLoading(false);
            return null;
        }
    }

    const handleRequestModal = (r: { id: string, rate: number; review: string; createdAt: Date; }) => {
        setEditableReview(r);
        setEditableRequest(requests?.filter(req => req.review === r.id)[0]);
        setRequestModal(true);
    }

    const refresh = async () => {
        await doGetRequests();
        await doGetReviews();
    }

    return (
        <AdminPage title="Minhas avaliações" description="Avaliações que você recebeu dos compradores. Se alguma for indevida, solicite a exclusão para análise da equipe.">
            <AdminCard bodyClassName="p-3 md:p-4">
                {
                    loading ?
                        <AdminLoading />
                        : reviews?.length ?
                            <ul className="flex flex-col gap-3">
                                {
                                    reviews.map((r, i) => {
                                        const requested = requests?.map(req => req.review).includes(r.id);
                                        return (
                                            <li key={i} className="flex flex-col md:flex-row gap-4 rounded-xl border border-gray-200 bg-white p-4">
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex flex-wrap items-center gap-3 mb-2">
                                                        <TemplateStars width="20px" rate={r.rate} />
                                                        <span className="text-xs font-semibold text-gray-500">{parseTimestamp(r.createdAt)}</span>
                                                    </div>
                                                    <p className="text-sm text-gray-800 break-words">{r.review}</p>
                                                </div>
                                                <div className="flex md:flex-col items-center md:items-end justify-between gap-2 border-t border-gray-100 pt-3 md:border-0 md:pt-0 md:w-48 shrink-0">
                                                    {
                                                        requested ?
                                                            <AdminBadge tone="warning" dot>Exclusão solicitada</AdminBadge>
                                                            : <span />
                                                    }
                                                    <AdminButton size="sm" variant="secondary" onClick={() => handleRequestModal(r)}>{requested ? "Editar solicitação" : "Solicitar exclusão"}</AdminButton>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            : <AdminEmptyState icon={<StarLineIcon />} title="Nenhuma avaliação por enquanto" description="Quando um comprador avaliar uma venda sua, a avaliação aparece aqui." />
                }
            </AdminCard>
            {
                requestModal && editableReview ?
                <RequestModal request={editableRequest} review={editableReview} close={() => setRequestModal(false)} refresh={refresh} goodToast={() => setGoodToast(true)} badToast={() => setBadToast(true)}/>
                : null
            }
            <AdminToast message="Solicitação enviada!" toast={goodToast} setToast={setGoodToast} tone="success" />
            <AdminToast message="Erro!" toast={badToast} setToast={setBadToast} tone="danger" />
        </AdminPage>
    )
}